import type { JobStatus } from '@/features/jobs/types/job'

const submittedStatuses: JobStatus[] = ['completed', 'aborted']

export const isJobSubmitted = (status: JobStatus) =>
  submittedStatuses.includes(status)
